import { isServer } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { useSLTConfig } from '../../slt/config/SLTConfigProvider';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { Categories } from './model';

export const useCategories = (depth: number = 0): UseQueryResult<Categories> => {
    const { categories } = useSLTConfig();
    return useBffGet(
        'categories',
        [{ depth: depth.toString() }],
        [BffQueryKey.CATEGORIES, depth.toString()],
        {
            initialData: categories,
            enabled: !isServer,
        },
    );
};
